import { render } from "./PersonalizeProduct.vue?vue&type=template&id=7bf242cb&scoped=true"
import script from "./PersonalizeProduct.vue?vue&type=script&lang=js"
export * from "./PersonalizeProduct.vue?vue&type=script&lang=js"

import "./PersonalizeProduct.vue?vue&type=style&index=0&id=7bf242cb&scoped=true&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf242cb"]])

export default __exports__